// ModeleDetailsPage.jsx
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Popconfirm, Row, Col, Dropdown } from "antd";
import {
  EditFilled,
  LockFilled,
  UnlockFilled,
  DownOutlined,
  DeleteFilled,
  ReloadOutlined
} from "@ant-design/icons";
import LoadingPlaceholder from "../../components/utils/LoadingPlaceholder";
import Toast from "../../helpers/Toast";
import PageTitle from "../../components/utils/PageTitle";
import Main from "../../components/layouts/Main";
import { useUserContext } from "../../contexts/UserContext";
import Breadcrumb from "../../components/utils/Breadcrumb";
import ModeleEditForm from "../../components/modele/ModeleEditForm";
import { ModeleService } from "../../services/ModeleService";
import ModeleDetails from "../../components/modele/ModeleDetails";
import { catchError } from "../../services/DaoService";
import EtapeModeleByModeleList from "../../components/etapemodele/EtapeModeleByModeleList";


const ModeleDetailsPage = () => {
  const { uid } = useParams();
  const [modele, setModele] = useState(null);
  const [loading, setLoading] = useState(true);
  const { check } = useUserContext();
  const [editModalVisible, setEditModalVisible] = useState(false);
  const navigate = useNavigate();

  const load = useCallback(() => {
    setLoading(true);
    ModeleService.getInstance()
      .find(uid)
      .then((response) => {
        setModele(response.data);
      })
      .catch((error) => {
        catchError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [uid]);
  useEffect(() => {
    load();
  }, [load]);

  function openEditModal() {
    setEditModalVisible(true);
  }

  const handleEnable = () => {
    if (!modele) {
      return;
    }
    ModeleService.getInstance()
      .enable(uid)
      .then((response) => {
        Toast.success(response.message);
        setModele(response.data);
      })
      .catch((error) => {
        catchError(error);
      })
  };

  const handleDisable = () => {
    if (!modele) {
      return;
    }
    ModeleService.getInstance()
      .disable(uid)
      .then((response) => {
        Toast.success(response.message);
        setModele(response.data);
      })
      .catch((error) => {
        catchError(error);
      })
  };

  const handleDelete = () => {
    ModeleService.getInstance()
      .remove(modele.uid)
      .then(() => {
        navigate("/modele");
      })
      .catch((error) => {
        catchError(error);
      })
  };

  const handleUpdate = (updatedModele) => {
    setModele(updatedModele);
    setEditModalVisible(false);
  };

  const menuItems = [
    {
      key: "1",
      label: (
        <>
          {modele?.enabled ? (
            <Popconfirm
              title="Voulez-vous vraiment désactiver cet élément ?"
              onConfirm={handleDisable}
              okText="Désactiver" description="Vous ne pourrez plus utiliser cette donnée pour de futures enregistrements."
              cancelText="Annuler"
            >
              Désactiver
            </Popconfirm>
          ) : (
            <Popconfirm
              title="Voulez-vous vraiment procéder ?"
              onConfirm={handleEnable}
              okText="Activer"
              cancelText="Annuler"
            >
              Activer
            </Popconfirm>
          )}
        </>
      ),
      danger: true,
      icon: modele?.enabled ? (
        <LockFilled />
      ) : (
        <UnlockFilled title="Activer" />
      ),
      permission: "VIEW-SETTINGS",
    },
    {
      key: "2",
      label: (
        <Popconfirm
          title="Voulez-vous vraiment procéder à la suppression ?"
          onConfirm={handleDelete}
          okText="Oui"
          okButtonProps={{ danger: true }}
          cancelText="Non"
        >
          Supprimer
        </Popconfirm>
      ),
      icon: <DeleteFilled />,
      danger: true,
      permission: "VIEW-SETTINGS",
    }
  ];

  const allowedMenuItems = menuItems.filter((menuItem) =>
    check(menuItem.permission)
  );

  return (
    <Main>
      <Breadcrumb
        parentLink="/modele"
        canSee={check("VIEW-SETTINGS")}
        parentLinkTitle="Liste des modeles"
        title={modele?.nom ?? "En chargement..."}
      />
      <PageTitle
        title={modele ? modele.nom : "modele"} subTitle={"Modele d'affaire"}
      >
        <Button
          type="default"
          icon={<ReloadOutlined />}
          onClick={load}
          loading={loading}
        >
          Rafraîchir
        </Button>
        {check("VIEW-SETTINGS") && (
          <Button
            type="default"
            icon={<EditFilled />}
            onClick={openEditModal}
            style={{ backgroundColor: ' #facc15' }}
          >
            Éditer
          </Button>
        )}
        {allowedMenuItems?.length > 0 && (
          <Dropdown
            menu={{ items: allowedMenuItems }}
          >
            <Button type="default" icon={<DownOutlined />}>
              Actions
            </Button>
          </Dropdown>
        )}
      </PageTitle>
      {loading ? (
        <LoadingPlaceholder />
      ) : (
        <Row gutter={[5, 5]}>
          <Col span={24}>
            <ModeleDetails modele={modele} />
          </Col>
          <Col span={24}>
            <EtapeModeleByModeleList modele={modele} />
          </Col>
        </Row>
      )}
      {modele ? <ModeleEditForm
        visible={editModalVisible}
        uid={modele.uid}
        onUpdate={handleUpdate}
        onCancel={() => setEditModalVisible(false)}
      /> : null}
    </Main>
  );
};

export default ModeleDetailsPage;